import { useEffect } from 'react';
import { useRouter } from 'next/router';

/**
 * Redirect stub — Facturas page merged into unified Documentos page.
 */
export default function FacturasRedirect() {
  const router = useRouter();
  useEffect(() => {
    router.replace('/asesor/documentos-pendientes');
  }, [router]);
  return null;
}
